import { render, staticRenderFns } from "./ThirdStepContainer.vue?vue&type=template&id=4a6ab210&scoped=true&lang=html&"
import script from "./ThirdStepContainer.vue?vue&type=script&lang=ts&"
export * from "./ThirdStepContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdStepContainer.vue?vue&type=style&index=0&id=4a6ab210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ab210",
  null
  
)

export default component.exports